import {BrandID} from '../enums/brand-id';

export class StockQuoteRequest {

  brandID!: BrandID;
  serialNumbers!: string[];

}
